import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_draft_order_filter_drown",
  ref: "draftOrderRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-950px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_draft_order_filter_drown_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-400" }, null, -1)
const _hoisted_7 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6 form-group mb-7" }
const _hoisted_12 = { class: "form-label fw-bold" }
const _hoisted_13 = {
  key: 0,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_14 = { class: "form-label fw-bold" }
const _hoisted_15 = { class: "col-md-6 form-group mb-7" }
const _hoisted_16 = { class: "form-label fw-bold" }
const _hoisted_17 = { class: "col-md-6 form-group mb-7" }
const _hoisted_18 = { class: "form-label fw-bold" }
const _hoisted_19 = { class: "modal-footer align-items-center justify-content-end gap-2 max-sm-justify-content-center" }
const _hoisted_20 = { class: "svg-icon svg-icon-3" }
const _hoisted_21 = { class: "svg-icon svg-icon-3" }
const _hoisted_22 = {
  class: "menu menu-sub menu-sub-dropdown w-250px w-md-600px",
  "data-kt-menu": "true"
}
const _hoisted_23 = { class: "px-7 py-5" }
const _hoisted_24 = { class: "fs-5 text-dark fw-bolder" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_26 = { class: "px-7 py-5" }
const _hoisted_27 = { class: "row max-sm-mh-300px" }
const _hoisted_28 = { class: "col-md-6 form-group mb-7" }
const _hoisted_29 = { class: "form-label fw-bold" }
const _hoisted_30 = {
  key: 0,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_31 = { class: "form-label fw-bold" }
const _hoisted_32 = { class: "col-md-6 form-group mb-7" }
const _hoisted_33 = { class: "form-label fw-bold" }
const _hoisted_34 = { class: "col-md-6 form-group mb-7" }
const _hoisted_35 = { class: "form-label fw-bold" }
const _hoisted_36 = { class: "d-flex justify-content-end" }
const _hoisted_37 = {
  type: "submit",
  class: "btn btn-sm btn-primary",
  "data-kt-menu-dismiss": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_window_resize = _resolveComponent("window-resize")!

  return (_openBlock(), _createBlock(_component_window_resize, null, {
    sm: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            ref: "formRef",
            model: _ctx.formData
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", _hoisted_5, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.t("common.filterOptions")), 1)
                    ]),
                    _hoisted_6
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("salesOrder.customer")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "customer_id" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            ref: "selectCustomer",
                            onFocus: _ctx.cancelReadonly,
                            "onHook:mounted": _ctx.cancelReadonly,
                            onVisibleChange: _ctx.cancelReadonly,
                            teleported: false,
                            modelValue: _ctx.formData.customer_id,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.customer_id) = $event)),
                            filterable: "",
                            clearable: "",
                            "remote-show-suffix": "",
                            remote: "",
                            placeholder: _ctx.t('common.plsEnter'),
                            "remote-method": _ctx.searchCustomerItems,
                            loading: _ctx.options.customerLoading
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.customer, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "placeholder", "remote-method", "loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    (_ctx.type === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("salesOrder.type")) + ":", 1),
                          _createVNode(_component_el_form_item, { prop: "config_id" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.formData.config_id,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.config_id) = $event)),
                                clearable: "",
                                placeholder: _ctx.t('common.plsSelect')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.config_id, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value,
                                      disabled: item.value == '2'
                                    }, null, 8, ["label", "value", "disabled"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("common.createdDateStart")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "created_at_start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            class: "w-100",
                            modelValue: _ctx.formData.created_at_start,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.created_at_start) = $event)),
                            type: "date",
                            placeholder: _ctx.t('common.pickDate'),
                            teleported: false
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("common.createdDateEnd")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "created_at_end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            class: "w-100",
                            modelValue: _ctx.formData.created_at_end,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.created_at_end) = $event)),
                            type: "date",
                            placeholder: _ctx.t('common.pickDate'),
                            teleported: false
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    type: "reset",
                    class: "btn btn-light",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_20, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr059.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.reset")), 1)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_21, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.apply")), 1)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ], 512)
    ]),
    lg: _withCtx(() => [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.t("common.filterOptions")), 1)
        ]),
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_el_form, {
            ref: "formRef",
            onSubmit: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.t("salesOrder.customer")) + ":", 1),
                  _createVNode(_component_el_form_item, { prop: "customer_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        ref: "selectCustomer",
                        onFocus: _ctx.cancelReadonly,
                        "onHook:mounted": _ctx.cancelReadonly,
                        onVisibleChange: _ctx.cancelReadonly,
                        teleported: false,
                        modelValue: _ctx.formData.customer_id,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.customer_id) = $event)),
                        filterable: "",
                        clearable: "",
                        "remote-show-suffix": "",
                        remote: "",
                        placeholder: _ctx.t('common.plsEnter'),
                        "remote-method": _ctx.searchCustomerItems,
                        loading: _ctx.options.customerLoading
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.customer, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "placeholder", "remote-method", "loading"])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.type === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.t("salesOrder.type")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "config_id" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.formData.config_id,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.config_id) = $event)),
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.config_id, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value,
                                  disabled: item.value == '2'
                                }, null, 8, ["label", "value", "disabled"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.t("common.createdDateStart")) + ":", 1),
                  _createVNode(_component_el_form_item, { prop: "created_at_start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        class: "w-100",
                        modelValue: _ctx.formData.created_at_start,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.created_at_start) = $event)),
                        type: "date",
                        placeholder: _ctx.t('common.pickDate')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.t("common.createdDateEnd")) + ":", 1),
                  _createVNode(_component_el_form_item, { prop: "created_at_end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        class: "w-100",
                        modelValue: _ctx.formData.created_at_end,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.created_at_end) = $event)),
                        type: "date",
                        placeholder: _ctx.t('common.pickDate')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-sm btn-light btn-active-light-primary me-2",
                  "data-kt-menu-dismiss": "true",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)))
                }, _toDisplayString(_ctx.t("common.reset")), 1),
                _createElementVNode("button", _hoisted_37, _toDisplayString(_ctx.t("common.apply")), 1)
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ])
    ]),
    _: 1
  }))
}